/**
 * AUTH.ACTIONS
 * Actions for authentication
 */

export const _authEmail = (id, isAdmin) => ({
  type: "API",
  payload: {
    method: "POST",
    url: "/_auth/email",
    data: {
      id,
      isAdmin
    }
  }
})

export const _authPassword = (email) => ({
  type: "API",
  payload: {
    method: "POST",
    url: "/_auth/password",
    data: {
      email
    }
  }
})

export const _authReporting = () => ({
  type: "ARCHIVE",
  payload: {
    url: "/auth"
  }
})

export const _authSsoChallenge = (org: string) => ({
  type: "API",
  payload: {
    method: "POST",
    url: "/_auth/sso/challenge",
    data: {
      org
    }
  }
})

export const _authSsoAuthenticate = (code: string) => ({
  type: "API",
  payload: {
    method: "POST",
    url: "/_auth/sso/authenticate",
    data: {
      code
    }
  }
})

// The identity comes from the Firebase ID token header; nothing in the body is trusted.
export const _authSupervisor = () => ({
  type: "API",
  payload: {
    method: "POST",
    url: "/_auth/supervisor",
    data: {}
  }
})
